import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Input, Button, Modal, Spin } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import logo from '../../../assets/SMYO_logo-31.png'
import api from '../../services/api'
import styles from '../../services/styles'
import GeneralContext from '../../../context/GeneralContext/GeneralContext'
import { displayMessage } from '../../../services/helper';
import RecoverPassword from '../../components/modals/RecoverPassword';
import { SL_CountrySelector } from '../../../components/selects/SL_CountrySelector';

const { bc1, tc2  } = styles

const Login = () => {

    const {
        setLoggedUser,
        mobile_mode,
        setUser,
        setEnums,
        setShowLoading,
        selectedLanguage,
        handleSetSelectedLanguage
    } = useContext(GeneralContext)

    const [errorLogin, setErrorLogin] = useState(null);
    const [isModalRecuperarSenhaVisible, setIsModalRecuperarSenhaVisible] = useState(false)

    const [email, setEmail] = useState(null)

    const navigate = useNavigate()
    
    useEffect(()=>{
        loadLanguages()
    },[])
    
    const loadLanguages = async () => {
        setShowLoading(true)
        try {
            const enums = await api.auth.getEnums()
            setEnums(enums.data)

            let storedCountryCode = localStorage.getItem("language")
            if (!storedCountryCode) {
                await fetch("https://ipapi.co/json/")
                .then(response => response.json())
                .then(data => {
                    const { languages } = data;
                    
                    let code = enums.data?.ECountries.BR.code;
                    if (languages.includes("pt")) {
                      code = enums.data?.ECountries.BR.code
                    } else if (languages.includes("en")) {
                      code = enums.data?.ECountries.EN.code
                    } else if (languages.includes("es")) {
                      code = enums.data?.ECountries.ES.code
                    } else if (languages.includes("fr")) {
                        code = enums.data?.ECountries.FR.code
                      }
                    localStorage.setItem("language", code)
                    handleSetSelectedLanguage(code)
                })
                .catch(error => {
                    console.error("Error fetching country info:", error);
                    const defaultCountryCode = 1
                    localStorage.setItem("language", defaultCountryCode)
                    handleSetSelectedLanguage(defaultCountryCode)
                    window.location.reload()
                })
            }
            else {
                handleSetSelectedLanguage(storedCountryCode)
            }            
        } catch (error) {            
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }

    async function onFinish(values) {
        setShowLoading(true)
        try {
            const rs = await api.auth.login({...values, lenguage_code: selectedLanguage})
            const {token, patient } = rs?.data

            const formattedToken = 'Bearer ' + token
            await api.auth.setAuthorizationToken(formattedToken)
            localStorage.setItem('user', JSON.stringify(patient))

            setUser(patient)
            setLoggedUser(true)

            if (patient?.must_change_password) {
                navigate('/changePassword')
            } else{
                navigate('/patient-home')
            }
        } catch (e) {
            setErrorLogin(e?.response?.data?.error ? e?.response?.data?.error : displayMessage('INVALID_LOGIN'))
        } finally {
            setShowLoading(false)
        }
    }

    async function handleOkPasswordRecovery(){
        setShowLoading(true)
        try {
            if (!email) {
                alert(displayMessage('INVALID_EMAIL'), 'error')
                return
            }
    
            await api.auth.forgotPassword(email) 
            alert(displayMessage('FORGOT_PASSWORD_SUCCESS'), 'success')
            handleCloseModalRecuperarSenha()

            } catch (error) {
                console.log(error)
            } finally {
                setShowLoading(false)
            }
    }

    function handleCloseModalRecuperarSenha(){
        setIsModalRecuperarSenhaVisible(false)
        setEmail(null)
    }

    return (
        <>
            {isModalRecuperarSenhaVisible && 
                <RecoverPassword
                    isModalRecoverPasswordOpen={isModalRecuperarSenhaVisible}
                    handleOnCloseModalRecoverPassword={handleCloseModalRecuperarSenha}
                    handleOnOkRecoverPassword={handleOkPasswordRecovery}
                    email={email}
                    setEmail={setEmail}
                />
            }

            <div className='w-[100vw] h-[100vh] flex justify-between text-center items-center'>
                <div style={{ height: '100%', background: bc1, display: mobile_mode ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center', flex: 2 }}>
                    <img
                        src={logo}
                        className='w-[70%] min-w-[300px]'
                    />
                </div>

                <div className={`h-[100%] flex justify-center items-center flex-1 ${mobile_mode ? 'min-w-[350px]' : 'min-w-[450px]'} flex-col`}>
                    <div className='flex flex-col items-center flex-1 justify-center'>
                        <div style={{ color: tc2, fontWeight: 'bold', marginBottom: 20, fontSize: mobile_mode ? 20 : 24 }}>{displayMessage('PATIENT_LOGIN')}</div>
                        <Form
                            name="normal_login"
                            initialValues={{ remember: true }}
                            labelCol={{ span: 25 }}
                            wrapperCol={{ span: 80 }}
                            onFinish={onFinish}
                            style={{ width: '65%' }}
                        >
                            <Form.Item
                                name="email"
                                rules={[{ required: true, message: displayMessage('DISPLAY_LOGIN') }]}
                            >
                                <Input 
                                    style={{ width: '100%' }} 
                                    prefix={<UserOutlined className="site-form-item-icon" />} 
                                    placeholder={displayMessage('LOGIN')} 
                                />
                            </Form.Item>

                            <Form.Item
                                name="password"
                                rules={[{ required: true, message: displayMessage('DISPLAY_PASSWORD') }]}
                            >
                                <div>
                                    <Input
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        placeholder={displayMessage('PASSWORD')}
                                    />
                                </div>
                            </Form.Item>

                            <Form.Item hasFeedback style={{ marginBottom: 10 }}>
                                <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                                    {displayMessage('ENTER')}
                                </Button>
                            </Form.Item>

                            <div className='flex justify-center'>
                                <Form.Item>
                                    <div>
                                        <Link to='' onClick={() => { setIsModalRecuperarSenhaVisible(true); setEmail(null) }} >{displayMessage('RECOVER_PASSWORD')}</Link>
                                    </div>
                                </Form.Item>
                           </div>
                        </Form>
                    </div>
                    <div className='flex f-1 w-full p-2 justify-end'>
                        <SL_CountrySelector isLogin={true}/>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;